/**
 * 一些格式化函数
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-09-02 15:58:33
 */
import { BooleanType } from '../types/advanced';
import { initialDateField, toDateString } from './time';
import { BrandType } from '../types/qualification/brand';
/**
 * 商标有效期格式化渲染函数
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-09-02 16:01:18
 * @param {number} timestamp 商标有效期(接口给的，单位秒)
 * @param {BooleanType} long_term_validity 是否长期有效
 */
export const brandValidityPeriodRender = (timestamp, long_term_validity) => long_term_validity === BooleanType.YES ? '长期有效' : toDateString(initialDateField(timestamp));
/**
 * 代理有效期格式化渲染函数
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-09-02 16:01:26
 * @param {number} timestamp 代理有效期(接口给的，单位秒)
 * @param {BrandType} brand_type 品牌类型 仅代理品牌有代理有效期
 */
export const agentValidityPeriodRender = (timestamp, brand_type) => brand_type === BrandType.Private ? '--' : toDateString(initialDateField(timestamp));
//# sourceMappingURL=format.js.map